var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2604 17.9998C24.2604 21.0226 22.15 23.1707 19.5466 23.1707C16.9432 23.1707 14.8328 21.0226 14.8328 17.9998C14.8328 14.977 16.9432 13.1707 19.5466 13.1707C22.15 13.1707 24.2604 14.977 24.2604 17.9998Z",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8315 35.3702C31.8315 38.4794 28.1952 40.9999 19.8315 40.9999C11.4679 40.9999 7.83154 38.4794 7.83154 35.3702C7.83154 32.261 13.2041 29.7405 19.8315 29.7405C26.459 29.7405 31.8315 32.261 31.8315 35.3702Z",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8315 8L36.5314 11.6603L40.5379 12.1459L37.582 14.8937L38.3583 18.8541L34.8315 16.892L31.3048 18.8541L32.0811 14.8937L29.1252 12.1459L33.1317 11.6603L34.8315 8Z",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileStar);
export default __webpack_public_path__ + "static/media/profile-star.50475b0ea1a9cbbbacd397165d98339d.svg";
export { ForwardRef as ReactComponent };